export default __webpack_public_path__ + "static/media/biceps.d1406058.png";